const layerDescriptions = {
    index:"The Tree Equity Score is a value between 0 and 100 that quantifies how equitable tree canopy cover is in Calgary using various priority indicators.",
    canopy_cover:"The percentage of a community that is covered by tree canopy.",
    canopy:"Zoom in to see outlines of individual trees.",
    aerial:"High resolution bird's eye view using aerial photography.",
    diff:"The change in tree canopy cover expressed as percentage change."
}

export {layerDescriptions };